import { render } from "./SupportMessagesView.vue?vue&type=template&id=7ae99734&ts=true"
import script from "./SupportMessagesView.vue?vue&type=script&lang=ts"
export * from "./SupportMessagesView.vue?vue&type=script&lang=ts"

import "./SupportMessagesView.vue?vue&type=style&index=0&id=7ae99734&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__